import { Button } from "primereact/button";
import CreateInvoiceItems from "./create-inv-items";
import CreateInvoiceTop from "./create-inv-top";
import { useEffect, useState, useRef } from "react";
import { InvoiceCheckoutModel } from "../../models/invoice/invoice-checkout-model";
import InvoicePayment from "./invoice-payment";
import '../../assests/css/common/responsive-ui.css'
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import orderServices from '../../services/orders/orderservice';
import {POSModel} from '../../models/orders/order-list-model';
import { Dialog } from "primereact/dialog";
import { AddProduct } from "../products/Add-product-inv";

const CreateInvoice = (props: any) => {

  const [invoiceCheckoutItem, setInvoiceCheckoutItem] = useState<InvoiceCheckoutModel | any>(null);
  const [paymentModeId, setPaymentModeId] = useState<number>(1);
  const [pointOfSale, setPointOfSale] = useState<any>();
  const [posData, setPOSData] = useState<POSModel | any>();
  const [posCodes, setPosCodes] = useState<any[]>([]);
  const [selectedAddr, setSelectedAddr] = useState("");
  const [isInvoiceCreating, setIsInvoiceCreating] = useState(false);
  const invoiceSubmitting = useRef(false);
  const [addProductVisible,setAddProductVisible] = useState(false);
   const [isPOSSelected, setIsPOSSelected] = useState(false);
  const [showpaymentOptions,setShowpaymentOptions] = useState<boolean>(true)
  const [isOrderDataEmpty, setIsOrderDataEmpty] = useState(true);

  const handleCreateInvoice = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (invoiceSubmitting.current) return;
    invoiceSubmitting.current = true;
    try {
      setIsInvoiceCreating(true);
      await props.runCreateInvoice(event, invoiceCheckoutItem, paymentModeId);
      props.runHideDialog();
    }
    catch {
      console.log("#Error at Create Invoice....!")
    } finally {
      invoiceSubmitting.current = false;
      setIsInvoiceCreating(false);
    }
  };

  const handleOrderDataEmptyChange = (isEmpty: boolean) => {
    setIsOrderDataEmpty(isEmpty);
  };

  const handlePOSChange = (e: DropdownChangeEvent) => {
    const selectedValue = e.value;
    setPointOfSale(selectedValue);
    setIsPOSSelected(!!selectedValue); 
    
    setInvoiceCheckoutItem((prevState: any) => ({
      ...prevState,
      posID: selectedValue
    }));
    
    const filteredPOS = posData.filter((item:any) => item.posID === selectedValue);
    let addressData = filteredPOS.map((item:any)=>{
      let data = 
      (item.address1 ? item.address1 + ", " : "") +
      (item.address2 ? item.address2 + ", " : "") +
      (item.landmark ? item.landmark + ", " : "") +
      (item.cityName ? item.cityName + ", " : "") +
      (item.stateName ? item.stateName + ", " : "") +
      (item.zipcode ? "Pin: " + item.zipcode : "");
    return data.trim();
    })
    setSelectedAddr(addressData)
  }

  const getALLPOS = () => {
    orderServices.getPOS().then((response: POSModel[]) => {
      setPOSData(response);
      const posCodes = response.map(item => ({ name: item.posCode, code: item.posID }));
      setPosCodes(posCodes);
      if (response.length === 1) {
        const singlePOS = response[0];
        setPointOfSale(singlePOS.posID);
        setIsPOSSelected(true);
        
        setInvoiceCheckoutItem((prevState: any) => ({
          ...prevState,
          posID: singlePOS.posID
        }));
        
        let addressData = 
          (singlePOS.address1 ? singlePOS.address1 + ", " : "") +
          (singlePOS.address2 ? singlePOS.address2 + ", " : "") +
          (singlePOS.landmark ? singlePOS.landmark + ", " : "") +
          (singlePOS.cityName ? singlePOS.cityName + ", " : "") +
          (singlePOS.stateName ? singlePOS.stateName + ", " : "") +
          (singlePOS.zipcode ? "Pin: " + singlePOS.zipcode : "");
        
        setSelectedAddr(addressData.trim());
      }
    }).catch(error => {
      console.error("Error fetching POS:", error);
    });
  };

  useEffect(()=>{
    setInvoiceCheckoutItem(props.OrderData);
    if(props.OrderData.paymentAlreadyCharged){
        setShowpaymentOptions(false)
    }
    getALLPOS();
  },[])

  const updateItem = (newItems: any, taxableAmt: number, taxAmt: number, disAmt: number, posID: string) => {
    setInvoiceCheckoutItem((prevState: any) => ({
      ...prevState, 
      orderDetail: newItems, 
      orderInvoiceDetail: newItems, 
      taxableAmount: Math.round(taxableAmt * 100) / 100,
      taxAmount: Math.round(taxAmt * 100) / 100, discountAmount: disAmt
    }));
  };

  const updateItemAfterAdd = (newItems: any) => {
    const updatedOrderData = {
      ...invoiceCheckoutItem,
      orderDetail: [...newItems.orderDetail],
      orderInvoiceDetail: [...newItems.orderDetail],
    };

    setInvoiceCheckoutItem(updatedOrderData);

    props.setOrderData(updatedOrderData);
  };

  function handelAddProduct(){
    setAddProductVisible(true);
  }

  function handelOnHide(){
    setAddProductVisible(false);
  }

  return (
    <>
      <div className="flex flex-column border-1 surface-border box-shadow-none m-0">
        <CreateInvoiceTop orderData={props.OrderData} />
        <div className="flex pl-3 mb-3 col-12 sm:col-12 lg:col-12 border-round">
          <p className="pos-text mt-3 font-bold">Point Of Sale: </p> <span className="required">*</span>
          <div className="ml-4 lg:col-3">
          <Dropdown
            options={posCodes}
            optionLabel="name"
            optionValue="code"
            value={pointOfSale}
            onChange={handlePOSChange}
            placeholder="Select POS" style={{ width: "100%" }}
            required
            className={!isPOSSelected && pointOfSale === "" ? "p-invalid" : ""}
          />
          {!isPOSSelected && pointOfSale === "" && (
            <small className="p-error">POS is required</small>
          )}
          </div>
          <p className="ml-4 mt-2">{selectedAddr && selectedAddr}</p>
        </div>
        {
          showpaymentOptions ? 
            <>
              <div className="pl-3 mb-3">
               <p>Select payment mode: </p>
               <InvoicePayment updatePaymentId={setPaymentModeId} /><br />
              </div>
              <div>
                <div className="ml-3">
                  <Button label="Add Product" onClick={handelAddProduct}></Button>
                </div>
                <div className="col-1">

                </div>
                <Dialog
                  header={("Add Product")}
                  visible={addProductVisible}
                  style={{ width: "67vw" }}
                  onHide={handelOnHide}
                  className="addProduct-dialog">
                 <AddProduct orderedItems={invoiceCheckoutItem} updateItems={updateItemAfterAdd} ></AddProduct>
                </Dialog>
              </div> 
          </>  : ""
        }
        <CreateInvoiceItems key={JSON.stringify(invoiceCheckoutItem?.orderDetail)} orderedItems={invoiceCheckoutItem} updateItems={updateItem} onOrderDataEmptyChange={handleOrderDataEmptyChange} />:<></>;
      </div>
      <div className="flex justify-content-end flex-wrap mt-2">
        <Button label="Close" className="border-round mt-2 ml-2 responsive-button" onClick={props.runHideDialog} style={{ width: "20%", textAlign: 'center' }} severity="warning" />
        <Button label="Generate Invoice" className="border-round mt-2 ml-2 responsive-button" onClick={(e) => { !isInvoiceCreating && handleCreateInvoice(e) }} style={{ width: "20%", textAlign: 'center' }} severity="success" disabled={!isPOSSelected || isInvoiceCreating || isOrderDataEmpty } />
      </div>
    </>
  );
};

export default CreateInvoice;
